import React from "react";
import { InterviewType } from "types/graphqlapi";
import { Calendar } from "@styled-icons/ionicons-outline/Calendar";
import { Timer } from "@styled-icons/ionicons-outline/Timer";
import { newColors } from "constants/newColors";
import styled from "styled-components";

export const InterviewTypeIcon: React.FC<{
  interviewType: InterviewType | undefined | null;
  size: number;
}> = ({ interviewType, size }) => {
  return (
    <>
      {interviewType === InterviewType.TERM ? (
        <StyledCalendar size={size} />
      ) : (
        <StyledTimer size={size} />
      )}
    </>
  );
};

const StyledCalendar = styled(Calendar)`
  color: ${newColors.primaryLight};
`;

const StyledTimer = styled(Timer)`
  color: ${newColors.primaryLight};
`;
